// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___3brOA","headerBackBtn":"style__headerBackBtn___338bE","image":"style__image___1UGJQ","doneControls":"style__doneControls___hEuNW","doneBtn":"style__doneBtn___3INRh","closeBtnWrap":"style__closeBtnWrap___1YPUT","closeBtn":"style__closeBtn___21Qd2","labelsToggleTop":"style__labelsToggleTop___1u2dY","BigPlayButton":"style__BigPlayButton___1HSaM","hidden":"style__hidden___2gAJ4","toggleCameraBtn":"style__toggleCameraBtn___2k4AN","flashBtn":"style__flashBtn___30vMR"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/stickers/ui/screens/new-video-record/style.css
// module id = 1355
// module chunks = 0